import { Theme } from "@emotion/react";
import { Box, Button, Card, Stack, SxProps, Typography } from "@mui/material";
import { Link } from "react-router-dom";

interface IDashboardInfoCardProps {
  Icon: string;
  title: string;
  description: string;
  buttonText: string;
  link?: string;
  buttonSx?: SxProps<Theme>;
  id: string;
}

export default function DashboardInfoCardComponent({
  Icon,
  title,
  description,
  buttonText,
  link,
  id,
  buttonSx,
}: Readonly<IDashboardInfoCardProps>) {
  return (
    <Card
      sx={{
        py: "24px",
        px: "12px",
        minWidth: "260px",
        boxShadow: "none",
        width: { xs: "95%", md: "46%" },
      }}
    >
      <Stack direction="row" mb="24px" gap="6px">
        <img src={Icon} alt="image" />
        <Typography
          variant="captionDemiBold"
          color={({ palette }) => palette.dominant.main}
        >
          {title}
        </Typography>
      </Stack>
      <Box
        component={Typography}
        variant="footerMediumBold"
        color={({ palette }) => palette.dominant[400]}
        mb="24px"
      >
        {description}
      </Box>
      <Stack width="100%" justifyContent="center" alignItems="center" my="24px">
        <Button
          component={Link}
          to={link ?? ""}
          variant={id == "1" ? "contained" : "activeText2"}
          sx={{
            py: "12px",
            px: "18px",
            textDecoration: "none",
          }}
        >
          <Typography variant="footerDemiBold">{buttonText}</Typography>
        </Button>
      </Stack>
    </Card>
  );
}
